import { SteedosBuilder } from '../steedos-builder.class';

export const stores = {}
SteedosBuilder.stores = stores;
